<div #div class="w-100">
  <mat-form-field #formField floatLabel="auto" appearance="outline" class="w-100">
    <mat-label
      ><span class="bdg-mat-label">
        {{ label }}
      </span></mat-label
    >
    <textarea
      matInput
      #nativeElement
      [formControl]="control"
      [placeholder]="placeholder"
      [maxLength]="maxLength"
      (blur)="onBlurEvent()"
      style="resize: none"
      [style.height.px]="div.clientHeight - 69"
      [errorStateMatcher]="matcher"
    ></textarea>

    <mat-icon *ngIf="error()" matSuffix class="mat-error">error</mat-icon>
    <mat-hint>{{ hint }}</mat-hint>
    <mat-hint *ngIf="showLength" align="end">{{ lengthText }}</mat-hint>
    <mat-error *ngIf="error()">{{ error() }}</mat-error>
  </mat-form-field>
</div>
